import { render, staticRenderFns } from "./VerCliente.vue?vue&type=template&id=67c3c4e3&scoped=true"
import script from "./VerCliente.vue?vue&type=script&lang=js"
export * from "./VerCliente.vue?vue&type=script&lang=js"
import style0 from "./VerCliente.vue?vue&type=style&index=0&id=67c3c4e3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c3c4e3",
  null
  
)

export default component.exports